import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Cookies from 'universal-cookie';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import { NotificationManager } from 'react-notifications';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import LoadingBoxes from '../components/loadingBoxes';
import LoadingText from '../components/loadingText';
import { numberWithCommas, checkProfilePic, reloadPage, encodeUrl, checkMylistStatusCode } from '../utility/tool';
import { fetch_myfavorite } from '../actions/fetch_myfavorite';
import { userLogout } from '../utility/logout';
import icon_user from "../imgs/icons8-user-60.png";
import '../styles/k_sprite1.css';
import '../styles/myKolList.css';
import '../styles/spriteMyList.css';

let cookies = new Cookies();

const MylistInlineStyle = {
	floatingLabel: {
		color: 'rgba(0, 0, 0, 0.6)'
	},
	inputError: {
		position: 'absolute',
		left: '0',
		bottom: '-10px'
	},
	inputFavorite: {
		width: '200px',
		marginRight: '20px',
		verticalAlign: 'middle',
		fontFamily: '"Noto Sans TC","WenQuanYi Zen Hei","Heiti TC","Helvetica","Microsoft YaHei","Microsoft JhengHei","Arial","sans-serif"',
	},
	inputFavoriteUnderline: {
		borderColor: '#f48500',
	},
	createFavoriteRoot: {
		marginTop: '15px',
		height: '40px',
		verticalAlign: 'middle',
		fontFamily: '"Noto Sans TC","WenQuanYi Zen Hei","Heiti TC","Helvetica","Microsoft YaHei","Microsoft JhengHei","Arial","sans-serif"',
	},
	createFavoriteBtn: {
		height: '40px',
		lineHeight: '40px',
		verticalAlign: 'middle',
		fontFamily: '"Noto Sans TC","WenQuanYi Zen Hei","Heiti TC","Helvetica","Microsoft YaHei","Microsoft JhengHei","Arial","sans-serif"',
	},
	removeGroupModal: {
		width: '350px',
	},
	removeBtnLabel: {
		color: '#f48500',
	},
}

class MyKolList extends Component {
	constructor(props) {
		super(props)
		this.state = {
			formData: {
				name: '',
				collectionId: '',
				kols: ''
			},
			activeTabIndex: parseInt(cookies.get('groupNum')) || 0,
			editName: false,
			selectAll: false,
			selectedKol: [],
			submitted: false,
			removeGroupModal: false,
			removeGroupId: '',
		}
	}

	componentDidMount() {
		window.scrollTo(0, 0)

		const { formData } = this.state

		if (cookies.get('user_id')) {
			this.props.fetch_myfavorite(cookies.get('user_id'), formData, "get", cookies.get('token'))
		}

	}

	componentDidUpdate(prev) {
		const { myfavorite } = this.props

		if (prev.myfavorite !== myfavorite) {
			checkMylistStatusCode(myfavorite.status.code)
		}

	}

	addActiveClass = (el, idx) => {
		this.setState({
			activeTabIndex: idx,
			editName: false,
			selectAll: false,
			selectedKol: []
		})

		cookies.set('groupNum', idx, { path: '/', maxAge: 86400 })
	}

	handleChange = (event, value) => {
		const { formData } = this.state
		formData[event.target.name] = event.target.value.trim()
		this.setState({ formData })
	}

	openRemoveModal = (el) => {
		this.setState({
			removeGroupModal: true,
			removeGroupId: el.id,
		})
	}

	closeRemoveModal = () => {
		this.setState({
			removeGroupModal: false,
			removeGroupId: '',
		})
	}

	submitGroupName = () => {
		const { formData, submitted } = this.state

		if (submitted) {
			return
		}
		console.log(formData)

		this.props.fetch_myfavorite(cookies.get('user_id'), formData, "put", cookies.get('token'))

		this.setState({ editName: false })

		this.setState({ submitted: true }, () => {
			setTimeout(() => this.setState({ submitted: false }), 2000)
		})
	}

	editGroupName = (group) => {
		const { formData, editName } = this.state
		const orilist = this.getEditKolList(group)

		formData['name'] = group.name
		formData['collectionId'] = group.id
		formData['kols'] = orilist.join()

		this.setState({
			formData: formData,
			editName: !editName
		})
	}

	getEditKolList = (el) => {
		let flatKolData = el.kols.map((item) => {
			return item.uuid
		})

		return flatKolData
	}

	removeGroup = () => {
		const { removeGroupId } = this.state

		this.props.fetch_myfavorite(cookies.get('user_id'), removeGroupId, "delete", cookies.get('token'))

		this.setState({
			activeTabIndex: 0,
			removeGroupModal: false,
			removeGroupId: '',
		})
	}

	selectAllKol = (el) => {
		let oriList = this.getEditKolList(el)
		let listArray = this.state.selectedKol

		if (!el.kols.length) {
			return NotificationManager.error('尚未新增KOL', '失敗', 5000)
		}

		this.setState({ selectAll: !this.state.selectAll },
			() => {
				listArray = listArray.filter((item) => {
					return oriList.indexOf(item) < 0
				})

				if (this.state.selectAll) {
					listArray = listArray.concat(oriList)
				}

				this.setState({ selectedKol: listArray })
			}
		)

	}

	addKol = (data, isSelected) => {
		let listArray = this.state.selectedKol

		listArray = listArray.filter((item) => {
			return item !== data.uuid
		})

		if (isSelected !== 'active') {
			listArray.push(data.uuid)
		}

		this.setState({ selectedKol: listArray })

	}

	removeKol = (el) => {
		const { submitted } = this.state
		let newList = this.getEditKolList(el)
		let toRemove = this.state.selectedKol
		let params = {}

		if (!el.kols.length) {
			return NotificationManager.error('尚未新增KOL', '失敗', 5000)
		}

		if (!this.state.selectedKol.length) {
			return NotificationManager.error('請至少選取一個KOL', '失敗', 5000)
		}

		if (submitted) {
			return
		}

		newList = newList.filter((item) => {
			return toRemove.indexOf(item) < 0
		})

		params = {
			name: el.name,
			collectionId: el.id,
			kols: newList.join(),
		}

		console.log('new', params)

		this.props.fetch_myfavorite(cookies.get('user_id'), params, "put", cookies.get('token'))

		this.setState({ submitted: true }, () => {
			setTimeout(() => this.setState({ submitted: false }), 2000)
		})

	}

	checkCompareList = (el) => {
		const { selectedKol } = this.state
		let compareQueryString = `/compare?tags=`
			+ `&skills=`
			+ `&jobs=`
			+ `&fans_min=500`
			+ `&fans_max=30000000`
			+ `&period=30`
			+ `&sex=0,1,2`
			+ `&source=FB,YT,IG`
			+ `&kol_name=`
			+ `&cat_op=or`
			+ `&kols=${selectedKol.join()}`
			+ `&group_name=${el.name}`
		let redirect = encodeUrl(compareQueryString)

		if (!selectedKol.length) {
			return NotificationManager.error('請至少選取一個KOL', '失敗', 5000)
		}

		browserHistory.push(redirect);
	}

	checkSourceLink(link) {
		if (link) {
			return ''
		} else {
			return 'hideNumber'
		}
	}

	renderList() {
		const { myfavorite } = this.props

		if (myfavorite.data.length) {
			return (
				<div>
					{this.renderGroupList(myfavorite.data)}
					{this.renderGroupContent(myfavorite.data)}
				</div>
			)
		} else {
			return (
				<div className="errormsg">
					<p className="errormsgCenter">尚未新增收藏清單</p>
					<Link to="/" className="refreshBtn">
						<span className="refreshIconText">點我去首頁</span>
					</Link>
				</div>
			)
		}
	}

	renderGroupList(data) {
		let listArr = data.map((el, idx) => {
			let acitveTab = this.state.activeTabIndex === idx ? 'active' : ''
			return <div key={el.id} className={`groupListItem ${acitveTab}`} onClick={() => this.addActiveClass(el, idx)}>{el.name}</div>
		})

		return <div className="groupList">{listArr}</div>
	}

	renderGroupContent(data) {
		const { formData, activeTabIndex, editName, selectAll } = this.state

		let currentGroup = data.find((el, idx) => {
			return activeTabIndex === idx
		})
		let checkAllStatus = selectAll === true ? 'active' : ''

		return (
			<div className="groupContent">
				<div className="groupName">
					<p className={`currentName ${editName === true ? '' : 'active'}`}>{currentGroup.name}</p>
					<div className={`editNameWrap ${editName === true ? 'active' : ''}`}>
						<ValidatorForm
							ref={r => (this.form = r)}
							onSubmit={this.submitGroupName}
						>
							<TextValidator
								floatingLabelText="輸入修改群組名稱"
								onChange={this.handleChange}
								name="name"
								value={formData.name}
								validators={['required']}
								errorMessages={['名稱為必塡欄位']}
								className="textValidator"
								style={MylistInlineStyle.inputFavorite}
								floatingLabelStyle={MylistInlineStyle.floatingLabel}
								errorStyle={MylistInlineStyle.inputError}
								underlineFocusStyle={MylistInlineStyle.inputFavoriteUnderline}
							/>

							<RaisedButton
								className="addToFavoriteBtn"
								label="修改"
								type="submit"
								backgroundColor="#32333d"
								style={MylistInlineStyle.createFavoriteRoot}
								buttonStyle={MylistInlineStyle.createFavoriteBtn}
								labelColor="#fff"
							/>
						</ValidatorForm>
					</div>
					<span className="editBtn" onClick={() => this.editGroupName(currentGroup)}></span>
					<span className="deleteBtn" onClick={() => this.openRemoveModal(currentGroup)}>刪除群組</span>
				</div>
				<div className="groupAction">
					<p className={`actionItem selectAll ${checkAllStatus}`} onClick={() => this.selectAllKol(currentGroup)}>全選</p>
					<p className="actionItem remove" onClick={() => this.removeKol(currentGroup)}>移出收藏</p>
					{/*
					<p className="actionItem export">匯出CSV</p>
					*/}
					<p className="actionItem compare" onClick={() => this.checkCompareList(currentGroup)}>加入比較</p>
				</div>
				<div className="kolList">
					{this.renderKolItem(currentGroup.kols)}
				</div>
			</div>
		)
	}

	renderKolItem(data) {
		let kolItem = []

		if (data.length) {
			kolItem = data.map((el, idx) => {
				let isSelected = this.state.selectedKol.indexOf(el.uuid) > -1 ? 'active' : '';
				let queryString = `/meta?fid=${el.fid}`
					+ `&tags=`
					+ `&skills=`
					+ `&jobs=`
					+ `&fans_min=500`
					+ `&fans_max=30000000`
					+ `&period=30`
					+ `&sex=0,1,2`
					+ `&source=FB,YT,IG`
					+ `&kol_name=`
					+ `&cat_op=or`

				return (
					<div className="kolListItem" key={el.uuid}>
						<span className={`kolCheck ${isSelected}`} onClick={() => this.addKol(el, isSelected)}></span>
						<a href={encodeUrl(queryString)}>
							<div className="listSpacing">
								<div className="profilePic">
									<img src={checkProfilePic(el)} alt="fangroup_img" onError={(e) => { e.target.onerror = null; e.target.src = icon_user }} />
								</div>
								<div className="profileInfo">
									<div className="titleAttrWrapper">
										<p className="leaderTitle">{el.name}</p>
										<p className="leaderAttribute">屬性：{el.category}</p>
										<p className="leaderAttribute">
											總粉絲數：{numberWithCommas(el.total_fans)}
										</p>
									</div>
									<div className="sourceIconWrapper">
										<div className={`sourceIcon fb_inactive FB ${this.checkSourceLink(el.facebook_fans)}`}></div>
										<div className={`sourceIcon yt_inactive YT ${this.checkSourceLink(el.youtube_fans)}`}></div>
										<div className={`sourceIcon ig_inactive IG ${this.checkSourceLink(el.instagram_fans)}`}></div>
									</div>
								</div>
							</div>
						</a>
					</div>
				)
			})

			return <div>{kolItem}</div>
		} else {
			return (
				<div className="emptyResult">
					<div className="messageBox">
						<span className="k_sprite1 sprite-icon-notfound"></span>
						<p className="message">噢哦~尚未新增KOL</p>
					</div>
				</div>
			)
		}
	}

	render() {
		const {
			myfavorite,
			myfavorite_isloading,
			myfavorite_error,
		} = this.props;

		const actions = [
			<FlatButton
				label="取消"
				primary={false}
				onTouchTap={this.closeRemoveModal}
			/>,
			<FlatButton
				label="確定"
				primary={true}
				labelStyle={MylistInlineStyle.removeBtnLabel}
				onClick={this.removeGroup}
			/>
		]

		if (!cookies.get('user_id')) {
			return (
				<div className="errormsg">
					<p className="errormsgCenter">使用者ID無效，請重新登出[1]</p>
					<Link to="/" className="refreshBtn">
						<span className="refreshIconText">點我去首頁</span>
					</Link>
				</div>
			)
		}

		if (myfavorite_isloading) {
			return (
				<div>
					<LoadingBoxes />
					<LoadingText />
				</div>
			)
		}

		if (myfavorite.data === undefined) {
			return (
				<div className="errormsg">
					<p className="errormsgCenter">查無資料，請重新搜尋</p>
					<Link to="/" className="refreshBtn">
						<span className="refreshIconText">點我去首頁</span>
					</Link>
				</div>
			)
		}

		if (myfavorite_error !== false) {
			if (myfavorite_error.status === 401) {
				setTimeout(function () { userLogout(); }, 3000);
				return <p className="errormsg">您的登入期間已過期，請重新登入</p>;
			} else {
				return (
					<div className="errormsg">
						<p className="errormsgCenter">資料未完成載入，請稍後再試</p>
						<div className="refreshBtn" onClick={() => { reloadPage() }}>
							<span className="refreshIcon"></span>
							<span className="refreshIconText">重新整理</span>
						</div>
					</div>
				)
			}
		}

		return (
			<div className="myKolListWrapper">
				{this.renderList()}
				<Dialog
					actions={actions}
					modal={false}
					open={this.state.removeGroupModal}
					onRequestClose={this.closeRemoveModal}
					className="removeGroupModal"
					contentStyle={MylistInlineStyle.removeGroupModal}
				>
					確定要刪除群組嗎？
				</Dialog>
			</div>
		)
	}

}

function mapStateToProps({ myfavorite, myfavorite_isloading, myfavorite_error }) {
	return { myfavorite, myfavorite_isloading, myfavorite_error };
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({ fetch_myfavorite }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(MyKolList);



// WEBPACK FOOTER //
// ./src/containers/mykollist.js